import React from 'react';

const Footer: React.FC = () => {
  return (
    <div style={{borderRadius: '6px', background: 'var(--White-Color, #FFF)', padding: '27px', textAlign: 'center', marginTop: '20px'}}>
     <p>© {new Date().getFullYear()} Anheuser-Busch InBev. All rights reserved.</p>
    </div>
  );
};

export default Footer;
